import React, { useEffect, useRef, useState } from "react";
import "./OpenHomeFilterListingType.scss"; 
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";

interface Props {
  formik: any;
}

const OpenHomeFilterPostFrom: React.FC<Props> = ({ formik }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const postFromOptions = [
    { label: "Agencies", value: "agencies" },
    { label: "Agents", value: "agents" },
  ];

  const selected = postFromOptions.find(
    (option) => option.value === formik?.values?.selectedPostFrom
  );

  const handleSelect = (value: string) => {
    formik.setFieldValue("selectedPostFrom", value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="home-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Post From</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          readOnly
          className="filter-search-input"
          value={selected?.label || "Select Post From"}
          onClick={() => setOpen(!open)}
        />
        <div
          className={`filter-down-arrow-icon ${open ? "open-box" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {open && (
        <div className="agent-list-container">
          {postFromOptions.map((option) => (
            <div
              key={option.value}
              className="agent-list-item"
              onClick={() => handleSelect(option.value)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OpenHomeFilterPostFrom;